import * as angular from 'angular';
import {IController} from "angular";

export class ServiceTypeMultipleSelectCtrl implements IController {
  selectedTypes: any;
  noUnderline: any;
  options: any;
  ngPlaceholder: any;
  onChange: Function;

  /* @ngInject */
  constructor(private deliveriesConstants, private $mdSelect) {
  }

  $onInit() {
    if (!this.options || !this.options.length) {
      this.options = this.deliveriesConstants.serviceTypes;
    }
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  onReset() {
    this.onChange({serviceTypes: []});
    this.$mdSelect.hide();
  }

  onCancel() {
    this.$mdSelect.hide();
  }

  onSelect() {
    this.onChange({serviceTypes: this.selectedTypes});
    this.$mdSelect.hide();
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('serviceTypeMultipleSelect', {
    bindings: {
      selectedTypes: '<',
      noUnderline: '<?',
      options: '<?',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    template: require('./service-type-multiple-select.html').default,
    controller: ServiceTypeMultipleSelectCtrl
  });
